module.exports = __webpack_public_path__ + "media/luxury-2026/drone-photo-interior-0006228c.jpg";